import React from 'react';
import FeatureHeading from '../components/FeatureHeading';
import SMSCostComponent from '../components/SMSCost/Index';

interface SMSCostProps {}

const SMSCost: React.FC<SMSCostProps> = () => {
    return (
        <React.Fragment>
            <FeatureHeading title='SMS Costs Calculator' description='Count characters in your message and calculate sending costs' />
            <SMSCostComponent />
        </React.Fragment>
    );
};

export default SMSCost;
